import { useQuery } from "@tanstack/react-query";
import { ActivityReply } from "../../../api/generated";
import { getActivityReplies } from "../../../api/activityReply";

export const useActivityReplies = (activityId: string) => {
    const { data: activityReplies, isLoading } = useQuery<ActivityReply[]>({
        queryKey: ["activityReplies", activityId],
        queryFn: () => getActivityReplies(activityId),
    });

    return {
        activityReplies,
        isLoading,
    };
};
